import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import CustomIcon from '../custom_icon/custom_icon';

import { cases } from '../../data/main';

import styles from './case_slide.module.css';

import 'swiper/css';
import 'swiper/css/pagination';

const CaseSlide = ({ caseIndex }) => {
  const [swiper, setSwiper] = useState(null);

  const pagination = { clickable: false };

  useEffect(() => {
    if (!caseIndex) return;

    swiper && !swiper.destroyed && swiper.slideTo(caseIndex - 1);
  }, [swiper, caseIndex]);

  return (
    <Swiper
      onSwiper={(swiper) => setSwiper(swiper)}
      className={[styles.swiper, 'caseSwiper'].join(' ')}
      modules={[Pagination]}
      pagination={pagination}
      slidesPerView={1}
      allowTouchMove={true}
      speed={500}
      breakpoints={{
        900: {
          allowTouchMove: false,
        },
      }}
    >
      {cases &&
        cases.map((c) => {
          return (
            <SwiperSlide className={styles.slide} key={c.id}>
              <div className={styles.textBox}>
                <div className={styles.description}>
                  <h2>{c.type}</h2>
                  <span>{c.title}</span>
                </div>

                <Link to='solution/kiosk'>
                  <div className={styles.icon}>
                    <CustomIcon icon='arrow' width={30} height={30} />
                  </div>
                </Link>
              </div>

              <div className={styles.imgBox}>
                <h2 className={styles.title}>
                  다양한 업종에 어울리는
                  <br /> 우노스 결제 솔루션
                </h2>
                <LazyLoadImage
                  alt={`case_${c.id}`}
                  src={process.env.PUBLIC_URL + `/imgs/main/case/${c.id}.png`}
                  placeholderSrc={
                    process.env.PUBLIC_URL + `/imgs/main/case/${c.id}_blur.png`
                  }
                />
              </div>
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};

export default CaseSlide;
